/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OptionDto
 */
export interface OptionDto {
    /**
     * 
     * @type {string}
     * @memberof OptionDto
     */
    optionId: string;
    /**
     * 
     * @type {string}
     * @memberof OptionDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OptionDto
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof OptionDto
     */
    takeawayPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OptionDto
     */
    preSelected: boolean;
}

/**
 * Check if a given object implements the OptionDto interface.
 */
export function instanceOfOptionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "optionId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "preSelected" in value;

    return isInstance;
}

export function OptionDtoFromJSON(json: any): OptionDto {
    return OptionDtoFromJSONTyped(json, false);
}

export function OptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'optionId': json['optionId'],
        'name': json['name'],
        'price': json['price'],
        'takeawayPrice': !exists(json, 'takeawayPrice') ? undefined : json['takeawayPrice'],
        'preSelected': json['preSelected'],
    };
}

export function OptionDtoToJSON(value?: OptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'optionId': value.optionId,
        'name': value.name,
        'price': value.price,
        'takeawayPrice': value.takeawayPrice,
        'preSelected': value.preSelected,
    };
}

